import dayjs, { Dayjs } from 'dayjs';

export const TIME_FORMAT = 'HH:mm';
export const DEFAULT_INTERVAL_SECONDS = 60;

export interface IntervalRuleForm {
  start?: Dayjs;
  end?: Dayjs;
  seconds?: number;
}

/** 把 Dayjs 转成当天分钟数（0–1439）；非法返回 null。 */
export function minuteOfDay(value?: Dayjs): number | null {
  if (!value || !dayjs.isDayjs(value) || !value.isValid()) {
    return null;
  }
  return value.hour() * 60 + value.minute();
}

/** 客户端预校验：格式、end>start、时段两两不重合。返回错误文案，无错误返回 null。 */
export function validateIntervals(intervals: IntervalRuleForm[]): string | null {
  const ranges: { start: number; end: number; label: string }[] = [];
  for (const rule of intervals) {
    const start = minuteOfDay(rule.start);
    const end = minuteOfDay(rule.end);
    if (start === null || end === null) {
      return '请完整填写每个时段的开始和结束时间';
    }
    if (end <= start) {
      return `时段结束时间必须晚于开始时间（不允许跨天）：${rule.start!.format(
        TIME_FORMAT,
      )}-${rule.end!.format(TIME_FORMAT)}`;
    }
    if (rule.seconds == null || rule.seconds < 1) {
      return '每个时段的间隔秒数必须 ≥ 1';
    }
    ranges.push({
      start,
      end,
      label: `${rule.start!.format(TIME_FORMAT)}-${rule.end!.format(TIME_FORMAT)}`,
    });
  }
  ranges.sort((a, b) => a.start - b.start);
  for (let i = 1; i < ranges.length; i += 1) {
    if (ranges[i].start < ranges[i - 1].end) {
      return `时间段不能重合：${ranges[i - 1].label} 与 ${ranges[i].label}`;
    }
  }
  return null;
}
